import { adminRoutes, nonAdminRoutes } from '../../auth/routes/authRoutes';
import homeRoutes from '../../home/routes/homeRoutes';

export default [adminRoutes, nonAdminRoutes, homeRoutes];
